// extracted by mini-css-extract-plugin
export default {"inputContainer":"CreatePlaylist_inputContainer__D7Tuv","input":"CreatePlaylist_input__C5HCf","addButton":"CreatePlaylist_addButton__QwwIF"};